import { useLocation, useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import { useMutation } from "@apollo/client";
import { App, Form } from "antd";
import { useTranslation } from "react-i18next";
import { AppointmentType } from "../../types/user";
import { DELETE_APPOINTMENT } from "../../queries/appointments.gql";
import useCurrentUser from "../../hooks/useCurrentUser";

const useAppointmentEdit = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const { message } = App.useApp();
  const { refetchUser } = useCurrentUser();

  const [deleteAppointment, { loading }] = useMutation(DELETE_APPOINTMENT, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      message.success(t("apollo.success.deleteAppointment"));
      navigate(-1);
    },
    onError: ({ graphQLErrors }) => {
      message.error(graphQLErrors[0].message);
    }
  });

  const toggleModal = () => {
    setModalOpen((prevState) => !prevState);
  };

  const appointment: AppointmentType = useMemo(() => state?.appointment, [state]);

  const onSubmit = async () => {
    toggleModal();

    await deleteAppointment({
      variables: {
        id: Number(appointment.id),
        motivation: form.getFieldValue("motivation") ?? "Nessuna motivazione"
      }
    });

    refetchUser();
  };

  return {
    appointment,
    toggleModal,
    modalOpen,
    navigate,
    onSubmit,
    loading,
    form
  };
};

export default useAppointmentEdit;
